import { useSyncExternalStore } from 'react'
import { MfcRouteInfo } from '../../../types/state'
import { ROUTESTATE } from '../../state'
import { pubSubRouter } from '../../state/pubSub'

const getRoute =
    <T extends keyof MfcRouteInfo>(attribute: T) =>
    (): MfcRouteInfo[T] =>
        ROUTESTATE[attribute]
const subRoute = (callback) => pubSubRouter.on('change', callback)

export const useRouteSelector = <T extends keyof MfcRouteInfo>(
    attribute: T,
): MfcRouteInfo[T] => {
    return useSyncExternalStore(
        subRoute,
        getRoute(attribute),
        getRoute(attribute),
    )
}

const getPreload = (page: string) => () =>
    ROUTESTATE.preloadCache.get(page) ?? null
const subPreload = (callback) => {
    const offChange = pubSubRouter.on('change', callback)
    const offPreload = pubSubRouter.on('preload', callback)
    return () => {
        offChange()
        offPreload()
    }
}

/**
 * re-renders when the entry is replaced
 */
export const useRoutePreload = (page: string) =>
    useSyncExternalStore(subPreload, getPreload(page), getPreload(page))

export const useRouteData = (page: string) =>
    useRoutePreload(page)?.promise ?? null
